var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApiIconBulkFocus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "241px",
    height: "161px",
    viewBox: "0 0 241 161",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "API_icon_Bulk_newFocus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "API_icon_Bulk_newFocus",
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lv2_Icon_Frame_focus",
    transform: "translate(0.000000, 0.385946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Frame_focus"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A48923",
    x: 0,
    y: 0,
    width: 240,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#1A4480",
    x: 8,
    y: 8,
    width: 224,
    height: 144
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M73.3333333,56.1323441 L73.3333333,8.3859464 L166.666667,8.3859464 L166.666667,56.1323441 L232,56.1323441 L120,160.385946 L8,56.1323441 L73.3333333,56.1323441 Z",
    id: "Combined-Shape",
    fill: "#D9E8F6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(66.500000, 16.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-5",
    transform: "translate(30.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1715729,2 L4,2 C2.8954305,2 2,2.8954305 2,4 L2,86 C2,87.1045695 2.8954305,88 4,88 L73,88 C74.1045695,88 75,87.1045695 75,86 L75,22.8284271 L54.1715729,2 Z",
    id: "Combined-Shape",
    stroke: "#B49859",
    strokeWidth: 4,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-3",
    fill: "#B49859",
    transform: "translate(66.000000, 11.000000) scale(-1, -1) translate(-66.000000, -11.000000) ",
    points: "55 0 77 0 77 22"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-3",
    transform: "translate(20.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1715729,2 L4,2 C2.8954305,2 2,2.8954305 2,4 L2,86 C2,87.1045695 2.8954305,88 4,88 L73,88 C74.1045695,88 75,87.1045695 75,86 L75,22.8284271 L54.1715729,2 Z",
    id: "Combined-Shape",
    stroke: "#B49859",
    strokeWidth: 4,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-3",
    fill: "#B49859",
    transform: "translate(66.000000, 11.000000) scale(-1, -1) translate(-66.000000, -11.000000) ",
    points: "55 0 77 0 77 22"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-4",
    transform: "translate(10.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1715729,2 L4,2 C2.8954305,2 2,2.8954305 2,4 L2,86 C2,87.1045695 2.8954305,88 4,88 L73,88 C74.1045695,88 75,87.1045695 75,86 L75,22.8284271 L54.1715729,2 Z",
    id: "Combined-Shape",
    stroke: "#B49859",
    strokeWidth: 4,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-3",
    fill: "#B49859",
    transform: "translate(66.000000, 11.000000) scale(-1, -1) translate(-66.000000, -11.000000) ",
    points: "55 0 77 0 77 22"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1715729,2 L4,2 C2.8954305,2 2,2.8954305 2,4 L2,86 C2,87.1045695 2.8954305,88 4,88 L73,88 C74.1045695,88 75,87.1045695 75,86 L75,22.8284271 L54.1715729,2 Z",
    id: "Combined-Shape",
    stroke: "#B49859",
    strokeWidth: 4,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-3",
    fill: "#B49859",
    transform: "translate(66.000000, 11.000000) scale(-1, -1) translate(-66.000000, -11.000000) ",
    points: "55 0 77 0 77 22"
  })), /*#__PURE__*/React.createElement("text", {
    id: "101011-101100-001101",
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontSize: 16,
    fontWeight: "bold",
    "line-spacing": 16,
    fill: "#1A4480"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13,
    y: 42
  }, "101011"), /*#__PURE__*/React.createElement("tspan", {
    x: 13,
    y: 58
  }, "101100"), /*#__PURE__*/React.createElement("tspan", {
    x: 13,
    y: 74
  }, "001101"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIconBulkFocus);
export default __webpack_public_path__ + "static/media/API_icon_Bulk_Focus.f3538964ac2a82abf2209e7cf94c218c.svg";
export { ForwardRef as ReactComponent };